var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{attrs:{"title":_vm.i18n.title}},[_vm._v(" 23423 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }